var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGok3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 255,
    viewBox: "0 0 258 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.992 41.9584L160.992 63.6858L174.904 71.7179L174.904 49.9904L160.992 41.9584Z",
    fill: "#6580E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.99 63.6859L179.807 52.8221L193.719 60.8542L174.902 71.7179L160.99 63.6859Z",
    fill: "#6580E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.805 52.8221L179.805 118.004L193.717 126.036L193.717 60.8541L179.805 52.8221Z",
    fill: "#6580E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.807 118.004L160.99 128.868L174.902 136.9L193.719 126.036L179.807 118.004Z",
    fill: "#6580E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.992 128.868L160.992 150.595L174.904 158.627L174.904 136.9L160.992 128.868Z",
    fill: "#6580E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.992 150.595L85.7266 194.05L99.6385 202.082L174.904 158.627L160.992 150.595Z",
    fill: "#6580E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7266 194.05L85.7266 128.868L99.6385 136.9L99.6385 202.082L85.7266 194.05Z",
    fill: "#6580E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7225 128.868L123.356 107.14L137.268 115.172L99.6345 136.9L85.7225 128.868Z",
    fill: "#6580E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.359 107.14L123.359 128.868L137.271 136.9L137.271 115.172L123.359 107.14Z",
    fill: "#6580E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.361 128.868L104.545 139.731L118.457 147.763L137.273 136.9L123.361 128.868Z",
    fill: "#6580E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.539 139.731L104.539 161.458L118.451 169.49L118.451 147.763L104.539 139.731Z",
    fill: "#6580E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.541 161.459L160.99 128.868L174.902 136.9L118.453 169.491L104.541 161.459Z",
    fill: "#6580E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.992 128.868L160.992 63.6857L174.904 71.7178L174.904 136.9L160.992 128.868Z",
    fill: "#6580E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.99 63.6859L104.541 96.2768L118.453 104.309L174.902 71.7179L160.99 63.6859Z",
    fill: "#6580E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.539 96.2767L104.539 74.5492L118.451 82.5813L118.451 104.309L104.539 96.2767Z",
    fill: "#6580E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.541 74.5492L160.99 41.9583L174.902 49.9904L118.453 82.5813L104.541 74.5492Z",
    fill: "#6580E1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M160.99 41.9583L160.99 63.6857L179.807 52.822L179.807 118.004L160.99 128.868L160.99 150.595L85.7246 194.05L85.7245 128.868L123.358 107.14L123.358 128.868L104.541 139.731L104.541 161.458L160.99 128.868L160.99 63.6857L104.541 96.2766L104.541 74.5492L160.99 41.9583Z",
    fill: "#D9D9D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.246 44.0624L175.246 69.2221L186.256 75.5786L186.256 50.4189L175.246 44.0624Z",
    fill: "#6580E1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.241 69.2221L109.875 106.962L120.885 113.319L186.251 75.5786L175.241 69.2221Z",
    fill: "#6580E1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.875 106.962L109.875 157.282L120.885 163.638L120.885 113.319L109.875 106.962Z",
    fill: "#6580E1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.875 157.282L153.452 132.122L164.462 138.479L120.885 163.638L109.875 157.282Z",
    fill: "#6580E1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.457 132.122L153.457 106.962L164.467 113.319L164.467 138.479L153.457 132.122Z",
    fill: "#6580E1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.461 106.962L175.25 94.3825L186.26 100.739L164.471 113.319L153.461 106.962Z",
    fill: "#6580E1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.25 94.3825L175.25 144.702L186.26 151.059L186.26 100.739L175.25 94.3825Z",
    fill: "#6580E1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.241 144.702L88.0859 195.021L99.0957 201.378L186.251 151.058L175.241 144.702Z",
    fill: "#6580E1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0861 195.021L88.0861 94.3816L99.0958 100.738L99.0958 201.378L88.0861 195.021Z",
    fill: "#6580E1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0938 94.3817L175.249 44.0625L186.259 50.4189L99.1035 100.738L88.0938 94.3817Z",
    fill: "#6580E1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M175.249 44.0645L175.249 69.2243L109.883 106.964L109.883 157.284L153.46 132.124L153.46 106.965L175.249 94.3847L175.249 144.704L88.0939 195.023L88.0939 94.3838L175.249 44.0645Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5781 223.287V204.638L114.103 220.53V239.178L86.5781 223.287Z",
    fill: "#6580E1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5797 204.638L70.4297 213.963L97.9541 229.854L114.104 220.53L86.5797 204.638Z",
    fill: "#6580E1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4297 213.963V195.314L97.9541 211.205V229.854L70.4297 213.963Z",
    fill: "#061C43"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4312 195.314L54.2812 204.638L81.8057 220.53L97.9556 211.205L70.4312 195.314Z",
    fill: "#061C43"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2812 204.638V111.396L81.8057 127.288V220.53L54.2812 204.638Z",
    fill: "#061C43"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2812 111.396L70.4312 102.072L97.9556 117.963L81.8057 127.288L54.2812 111.396Z",
    fill: "#6580E1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4297 102.072V83.4239L97.9541 99.3151V117.963L70.4297 102.072Z",
    fill: "#6580E1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4297 83.4238L86.5797 74.0996L114.104 89.9908L97.9541 99.315L70.4297 83.4238Z",
    fill: "#6580E1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5781 74.0997V55.4513L114.103 71.3425V89.9909L86.5781 74.0997Z",
    fill: "#6580E1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5781 55.4512L167.328 8.83025L194.852 24.7215L114.103 71.3424L86.5781 55.4512Z",
    fill: "#6580E1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.328 8.83025V27.4786L194.853 43.3699V24.7215L167.328 8.83025Z",
    fill: "#6580E1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.328 27.4786L183.478 18.1544L211.003 34.0457L194.853 43.3699L167.328 27.4786Z",
    fill: "#6580E1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.484 18.1545V36.8029L211.009 52.6941V34.0457L183.484 18.1545Z",
    fill: "#6580E1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.484 36.8029L199.634 27.4787L227.159 43.3699L211.009 52.6941L183.484 36.8029Z",
    fill: "#6580E1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.633 27.4787V120.721L227.157 136.612V43.3699L199.633 27.4787Z",
    fill: "#6580E1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.634 120.721L183.484 130.045L211.009 145.936L227.159 136.612L199.634 120.721Z",
    fill: "#061C43"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.484 130.045V148.693L211.009 164.584V145.936L183.484 130.045Z",
    fill: "#6580E1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.478 148.693L167.328 158.017L194.853 173.909L211.003 164.584L183.478 148.693Z",
    fill: "#061C43"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.328 158.017V176.666L194.853 192.557V173.909L167.328 158.017Z",
    fill: "#6580E1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.328 176.666L86.5781 223.287L114.103 239.178L194.852 192.557L167.328 176.666Z",
    fill: "#061C43"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5781 223.287L114.103 239.178L86.5781 223.287Z",
    fill: "#6580E1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5812 223.287V204.638L70.4312 213.963V195.314L54.2812 204.638V111.396L70.4312 102.072V83.4239L86.5812 74.0997V55.4513L167.331 8.83032V27.4787L183.481 18.1545V36.8029L199.631 27.4787V120.721L183.481 130.045V148.693L167.331 158.017V176.666L86.5812 223.287Z",
    fill: "#16346C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6344_33042)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5812 223.287V204.638L70.4312 213.963V195.314L54.2812 204.638V111.397L70.4312 102.072V83.424L86.5812 74.0998V55.4514L167.331 8.83038V27.4788L183.481 18.1546V36.803L199.631 27.4788V120.721L183.481 130.045V148.693L167.331 158.018V176.666L86.5812 223.287Z",
    fill: "url(#paint0_linear_6344_33042)"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5497 65.9395L86.5497 87.272L102.764 96.6333L102.764 75.3009L86.5497 65.9395Z",
    fill: "#6580E1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5525 87.2708L68.0781 97.937L84.2925 107.298L102.767 96.6322L86.5525 87.2708Z",
    fill: "#6580E1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0787 97.9378L68.0787 161.935L84.2931 171.296L84.2931 107.299L68.0787 97.9378Z",
    fill: "#6580E1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0781 161.936L86.5525 151.269L102.767 160.631L84.2925 171.297L68.0781 161.936Z",
    fill: "#061C43"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5496 151.269L86.5496 172.601L102.764 181.963L102.764 160.631L86.5496 151.269Z",
    fill: "#6580E1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5625 172.601L160.46 129.936L176.674 139.297L102.777 181.962L86.5625 172.601Z",
    fill: "#061C43"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.454 129.935L160.454 65.9384L176.668 75.2998L176.668 139.297L160.454 129.935Z",
    fill: "#6580E1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.457 65.9386L123.508 87.2711L139.722 96.6324L176.671 75.3L160.457 65.9386Z",
    fill: "#6580E1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.503 87.2714L123.503 108.604L139.717 117.965L139.717 96.6328L123.503 87.2714Z",
    fill: "#6580E1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.508 108.603L141.982 97.9372L158.197 107.299L139.722 117.965L123.508 108.603Z",
    fill: "#6580E1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.979 97.9371L141.979 119.269L158.194 128.631L158.194 107.298L141.979 97.9371Z",
    fill: "#6580E1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.985 119.27L86.5625 151.269L102.777 160.63L158.2 128.631L141.985 119.27Z",
    fill: "#6580E1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5631 151.269L86.5631 87.2718L102.777 96.6332L102.777 160.63L86.5631 151.269Z",
    fill: "#6580E1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5625 87.2711L141.985 55.2727L158.2 64.6341L102.777 96.6324L86.5625 87.2711Z",
    fill: "#061C43"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.979 55.2741L141.979 33.9417L158.194 43.3031L158.194 64.6355L141.979 55.2741Z",
    fill: "#6580E1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.985 33.9408L86.5625 65.9392L102.777 75.3006L158.2 43.3022L141.985 33.9408Z",
    fill: "#6580E1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5531 65.9391L86.5531 87.2716L68.0787 97.9378L68.0787 161.935L86.5531 151.269L86.5531 172.601L160.45 129.936L160.45 65.9391L123.501 87.2716L123.501 108.604L141.976 97.9378L141.976 119.27L86.5531 151.269L86.5531 87.2716L141.976 55.2732L141.976 33.9408L86.5531 65.9391Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6344_33042",
    x: 50.2812,
    y: 8.83038,
    width: 149.352,
    height: 218.456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -14,
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6344_33042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6344_33042",
    x1: 145,
    y1: 14.1243,
    x2: 117.5,
    y2: 105.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#BBC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6580E1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGok3);
export default __webpack_public_path__ + "static/media/gok-3.7edd617214b176548dadac1372901f97.svg";
export { ForwardRef as ReactComponent };